
import {
  FETCH_CATEGORIES_REQUEST,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_CATEGORIES_FAILURE,
  ADD_CATEGORY_REQUEST,
  ADD_CATEGORY_SUCCESS,
  ADD_CATEGORY_FAILURE,
  DELETE_CATEGORY_REQUEST,
  DELETE_CATEGORY_SUCCESS,
  DELETE_CATEGORY_FAILURE,
  UPDATE_CATEGORY_REQUEST,
  UPDATE_CATEGORY_SUCCESS,
  UPDATE_CATEGORY_FAILURE,
  SWAP_CATEGORIES_SUCCESS,
  SWAP_CATEGORIES_FAILURE,
} from '../actions/categoryActions';

const initialState = {
  loading: false,
  categories: [],
  error: '',
  status: 'idle',
};

const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Categories Actions
    case FETCH_CATEGORIES_REQUEST:
      return { ...state, loading: true, status: 'loading' };
    case FETCH_CATEGORIES_SUCCESS:
      return { ...state, loading: false, categories: action.payload, status: 'succeeded' };
    case FETCH_CATEGORIES_FAILURE:
      return { ...state, loading: false, error: action.payload, status: 'failed' };

    // Add Category Actions
    case ADD_CATEGORY_REQUEST:
      return { ...state, loading: true, status: 'loading' };
    case ADD_CATEGORY_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        categories: [...state.categories, action.payload], 
        status: 'succeeded' 
      };
    case ADD_CATEGORY_FAILURE:
      return { ...state, loading: false, error: action.payload, status: 'failed' };

    // Delete Category Actions
    case DELETE_CATEGORY_REQUEST:
      return { ...state, loading: true, status: 'loading' }; // Deleting category
    case DELETE_CATEGORY_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        categories: state.categories.filter((category) => category._id !== action.payload), // Remove deleted category
        status: 'succeeded' 
      };
    case DELETE_CATEGORY_FAILURE:
      return { ...state, loading: false, error: action.payload, status: 'failed' };

    // Update Category Actions
    case UPDATE_CATEGORY_REQUEST:
      return { ...state, loading: true, status: 'loading' }; // Updating category
    case UPDATE_CATEGORY_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        categories: state.categories.map((category) => 
          category._id === action.payload._id ? action.payload : category
        ), 
        status: 'succeeded' 
      };
    case UPDATE_CATEGORY_FAILURE:
      return { ...state, loading: false, error: action.payload, status: 'failed' };

    // Swap Categories Actions
    case SWAP_CATEGORIES_SUCCESS:
      return { ...state, categories: action.payload };
    case SWAP_CATEGORIES_FAILURE:
      return { ...state, error: action.payload };

    default:
      return state;
  }
};

export default categoryReducer;
